import { createSelector } from 'reselect';
import { notificationsShowTypeSelector } from './notificationsShowType';

export const showNotificationsSelector = createSelector(
    notificationsShowTypeSelector,
    (notificationsShowType) => notificationsShowType !== 'None',
);
